import { createTheme } from "@mui/material";
import { colors } from "@zapalacorp/tokens";

declare module "@mui/material" {
  interface Color {
    "25"?: string;
  }
}
declare module "@mui/material/styles" {
  interface Color {
    "25"?: string;
  }
  interface PaletteColor {
    "25"?: string;
  }

  interface PaletteOptions {
    "25"?: string;
  }

  interface Theme {
    grey: {
      "25": string;
    };
  }
  // allow configuration using `createTheme`
  interface DeprecatedThemeOptions {
    grey?: {
      "25"?: string;
    };
  }
}

export const appTheme = createTheme({
  typography: {
    fontFamily: "Manrope",
  },
  shape: {
    borderRadius: 8,
  },
  palette: {
    primary: {
      main: colors.brandBlue500,
    },
    error: {
      main: colors.error600,
    },
    grey: {
      "25": colors.gray25,
      "50": colors.gray50,
      "200": colors.gray200,
      "400": colors.gray400,
    },
    background: {
      paper: "#FFF",
    },
  },
  brand: "",
  footerHeight: 0,
  mobileTopBarHeight: 0,
  mobileFooterHeight: 0,
  sidebarMobilePadding: 0,
  participantBorderWidth: 0,
});
